import React from "react";
import styled from "styled-components/macro";
import { device } from "../../device";

import { AddRideUnit } from ".";

const RideUnits = ({
  children,
  setRideItems,
  ride,
  readOnly,
  isPDF,
  itemsCount,
}) => {
  const isFormMode = window.location.pathname.includes("create_unit_form");
  let transform;

  if (isPDF && itemsCount !== 4) {
    transform = "scale(1.3)";
  }
  if (isFormMode) {
    transform = "scale(2.2)";
  }

  return (
    <Wrapper
      style={{
        width: isPDF && "100%",
        marginTop: isPDF ? 0 : isFormMode ? 50 : null,
        marginBottom: isFormMode && 200,
        transform,
      }}
    >
      <UnitsDiv>{children}</UnitsDiv>
      {!readOnly && <AddRideUnit ride={ride} setRideItems={setRideItems} />}
    </Wrapper>
  );
};

export default RideUnits;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  @media ${device.mobileS} {
    padding: 0px 39px;
  }
  @media ${device.tablet} {
    width: 100vw;
    padding: 0px 100px;
  }
`;

const UnitsDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  height: auto;
  @media ${device.mobileS} {
    gap: 16px;
  }
  @media ${device.laptop} {
    gap: 40px;
  }
`;
